import { render } from "./ProfilePanels.vue?vue&type=template&id=7fce62f4&scoped=true"
import script from "./ProfilePanels.vue?vue&type=script&lang=js"
export * from "./ProfilePanels.vue?vue&type=script&lang=js"

import "@/Common/Styles/profilePanels.scss?vue&type=style&index=0&id=7fce62f4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fce62f4"]])

export default __exports__